export default "__VITE_ASSET__BPf2huFd__"